import baseEditForm from 'formiojs/components/_classes/component/Component.form';

import AddDepartmentDisplay from 'formiojs/components/editgrid/editForm/EditGrid.edit.display';
import AddDepartmentValidation from 'formiojs/components/editgrid/editForm/EditGrid.edit.validation';
import AddDepartmentData from 'formiojs/components/editgrid/editForm/EditGrid.edit.data';

export default (...extend) => baseEditForm(
  [
    {
      key: 'display',
      components: AddDepartmentDisplay,
    },
    {
      key: 'data',
      components: AddDepartmentData,
    },
    {
      key: 'validation',
      components: AddDepartmentValidation,
    },
    {
      key: 'addons',
      ignore: true,
    },
    {
      label: 'Custom',
      key: 'custom',
      components: [
        {
          weight: 50,
          type: 'checkbox',
          label: 'Hide Custom Label',
          tooltip:
            'Hide the label (title, if no label) of this component. This allows you to show/hide the custom label when it is rendered.',
          key: 'hideCustomLabel',
          input: true,
        },
      ],
    },
  ],
  ...extend,
);
